module.exports = __webpack_public_path__ + "static/img/private-board.1ead633.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innovation/private-board.jpeg
// module id = pJ1S
// module chunks = 2